import { render, staticRenderFns } from "./advanceCorporateShareHoldersSettings.vue?vue&type=template&id=558fdc39"
import script from "./advanceCorporateShareHoldersSettings.vue?vue&type=script&lang=js"
export * from "./advanceCorporateShareHoldersSettings.vue?vue&type=script&lang=js"
import style0 from "./advanceCorporateShareHoldersSettings.vue?vue&type=style&index=0&id=558fdc39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports